const { createAction } = require('../../helpers');
const {
  GET_SERVICES,
  GET_SERVICES_SUCCESS,
  GET_SERVICES_RESET,
  GET_SERVICES_ERROR,

  GET_CATALOGUE,
  GET_CATALOGUE_SUCCESS,
  GET_CATALOGUE_RESET,
  GET_CATALOGUE_ERROR,

  GET_PACKAGES,
  GET_PACKAGES_SUCCESS,
  GET_PACKAGES_RESET,
  GET_PACKAGES_ERROR,
} = require('./constants');

/**
 * @param {Array<string>} iatas
 * @return {Promise<*>}
 */

const getServices = ({ categorySearch, size, pageSize }) =>
  createAction(GET_SERVICES, { categorySearch, size, pageSize });

const getServicesSuccess = (data) =>
  createAction(GET_SERVICES_SUCCESS, { data });

const getServicesError = (error) => createAction(GET_SERVICES_ERROR, { error });

const getServicesReset = () => createAction(GET_SERVICES_RESET);

const packages = (uuid) => createAction(GET_PACKAGES, { uuid });

const packagesSuccess = (data) => createAction(GET_PACKAGES_SUCCESS, { data });

const packagesError = (error) => createAction(GET_PACKAGES_ERROR, { error });

const packagesReset = () => createAction(GET_PACKAGES_RESET);

const catalogue = () => createAction(GET_CATALOGUE);

const catalogueSuccess = (data) =>
  createAction(GET_CATALOGUE_SUCCESS, { data });

const catalogueError = (error) => createAction(GET_CATALOGUE_ERROR, { error });

const catalogueReset = () => createAction(GET_CATALOGUE_RESET);

module.exports = {
  packages,
  packagesSuccess,
  packagesError,
  packagesReset,
  getServices,
  getServicesSuccess,
  getServicesError,
  getServicesReset,
  catalogue,
  catalogueSuccess,
  catalogueError,
  catalogueReset,
};
